import { MS_IN_MINUTE } from '../../../utils/time-utils';
import type {
  InterstitialSlotName,
  InterstitialStrategy,
  InterstitialStrategyContext,
  InterstitialStrategyState,
} from './InterstitialStrategy';

/**
 * Legacy logic for backward compatibility (Facebook/Web platforms)
 * - Level > 100: win always, lost every 3rd
 * - Level 50-100: win every 2nd, lost never
 * - Level < 50: never
 * - ROW (non-Tier1): level > 10, 5min cooldown
 */
export class LegacyInterstitialStrategy implements InterstitialStrategy {
  constructor(
    private readonly context: InterstitialStrategyContext,
    private readonly state: InterstitialStrategyState,
  ) {}

  public canShowInterstitial(slotName: InterstitialSlotName): boolean {
    if (!this.context.isTier1()) {
      return this.canShowInterstitialROW();
    }
    if (this.context.isPayer()) return false;

    const levelNumber = this.context.getLevelNumber();

    if (levelNumber > 100) {
      if (slotName === 'win') return true;

      this.state.slotNameUseCounter.lost += 1;
      return this.state.slotNameUseCounter.lost % 3 === 0;
    }

    if (levelNumber > 50) {
      if (slotName === 'lost') return false;

      this.state.slotNameUseCounter.win += 1;
      return this.state.slotNameUseCounter.win % 2 === 0;
    }

    return false;
  }

  public shouldShowMidLevelInterstitial(): boolean {
    return false;
  }

  public recordInterstitialShown(): void {
    this.state.lastInterstitialTimestamp = Date.now();
    this.state.sessionAdCount += 1;
  }

  private canShowInterstitialROW(): boolean {
    return this.canShowByLevelAndCooldown({
      cooldown: MS_IN_MINUTE * 5,
      minLevel: 10,
    });
  }

  private canShowByLevelAndCooldown(config: { cooldown: number; minLevel: number }): boolean {
    const { cooldown, minLevel } = config;
    const lastInterstitialAdTime = this.context.getLastInterstitialAdTime();
    const levelOk = this.context.getLevelNumber() > minLevel;
    const adCooldownOk = Date.now() > lastInterstitialAdTime + cooldown;
    return levelOk && adCooldownOk;
  }
}
